export default __webpack_public_path__ + "static/media/doc-new.b44cb563.jpg";